export function initSearchOverlay(){

  const openBtn   = document.querySelector('.header__item--search');
  const overlay   = document.querySelector('.search-overlay');
  const wrap      = overlay?.querySelector('.search-overlay__wrap');
  const closeBtn  = overlay?.querySelector('.search-overlay__close');
  const input     = overlay?.querySelector('.search-overlay__input');
  const results   = overlay?.querySelector('.search-overlay__results');
  const siteURL   = overlay.dataset.siteurl;

  if(!overlay || !input || !results) return;

  let debounceTimer = null;
  let lastQuery = '';

  function closeOverlay(){

    overlay.classList.add('_out');

    setTimeout(()=>{
      overlay.classList.remove('_out');
      overlay.classList.remove('_open');

      input.value = '';
      results.innerHTML = '';
      lastQuery = '';

    },500);

  }

  // OPEN
  openBtn?.addEventListener('click', () => {

    overlay.classList.add('_open');

    setTimeout(()=>{
      input.focus();
    },300);

  });

  // CLOSE BUTTON
  closeBtn?.addEventListener('click', closeOverlay);

  // CLICK OUTSIDE
  overlay.addEventListener('click', (e)=>{

    if(!wrap.contains(e.target)){
      closeOverlay();
    }

  });

  // ESC close
  document.addEventListener('keydown', e=>{
    if(e.key === 'Escape' && overlay.classList.contains('_open')){
      closeOverlay();
    }
  });

  // SEARCH INPUT
  input.addEventListener('input', () => {

    const query = input.value.trim();

    if(query === lastQuery) return;

    lastQuery = query;

    clearTimeout(debounceTimer);

    debounceTimer = setTimeout(()=>{

      if(query.length < 2){
        results.innerHTML = '';
        return;
      }

      results.classList.add('_loading');

      fetch(`${siteURL}?s=${encodeURIComponent(query)}`)
        .then(res => res.text())
        .then(html => {

          const parser = new DOMParser();
          const doc = parser.parseFromString(html,'text/html');

          const articles = doc.querySelectorAll('article');

          results.innerHTML = '';

          if(!articles.length){

            results.innerHTML = `<div class="search-overlay__empty">No se encontraron resultados</div>`;
            return;

          }

          articles.forEach(article=>{
            results.appendChild(article);
          });

        })
        .finally(()=>{
          results.classList.remove('_loading');
        });

    },350);

  });

}